
export default function Comparison() {
  return (
    <section id="comparison" className="py-12 bg-[#112240]">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-3xl font-bold text-center mb-6 text-white">
          他の案件紹介サービスとの違い
        </h2>
        <div className="overflow-x-auto">
          <table className="w-full max-w-4xl mx-auto border-collapse bg-[#0d1b2e] rounded-lg overflow-hidden">
            <thead>
              <tr className="bg-[#0a1628]">
                <th className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-semibold text-amber-400">項目</th>
                <th className="border border-amber-400 px-3 py-2 text-xs md:text-sm font-semibold text-amber-400 bg-[#1a2f4e]">プロジェクトマスター</th>
                <th className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-semibold text-slate-300">一般的なエージェント</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-medium text-slate-300">単価</td>
                <td className="border border-amber-400 px-3 py-2 text-xs md:text-sm text-white bg-[#1a2f4e]">160万〜210万円中心</td>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm text-slate-300">100万前後</td>
              </tr>
              <tr>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-medium text-slate-300">プロジェクト内容</td>
                <td className="border border-amber-400 px-3 py-2 text-xs md:text-sm text-white bg-[#1a2f4e]">戦略・DX案件中心</td>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm text-slate-300">PMO中心</td>
              </tr>
              <tr>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-medium text-slate-300">商流</td>
                <td className="border border-amber-400 px-3 py-2 text-xs md:text-sm text-white bg-[#1a2f4e]">元請・上位会社案件</td>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm text-slate-300">多重商流</td>
              </tr>
              <tr>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm font-medium text-slate-300">サポート</td>
                <td className="border border-amber-400 px-3 py-2 text-xs md:text-sm text-white bg-[#1a2f4e]">直接コミュニケーション</td>
                <td className="border border-slate-600 px-3 py-2 text-xs md:text-sm text-slate-300">営業担当経由</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
